var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.481 6.64782C11.481 7.55563 11.0786 8.68573 10.3594 9.93233C9.65204 11.1584 8.69759 12.3962 7.73086 13.4932C7.07005 14.2431 5.92553 14.2457 5.25892 13.4961C4.26765 12.3813 3.31686 11.151 2.61911 9.93455C1.91168 8.70127 1.51904 7.57606 1.51904 6.64782C1.51904 4.09347 3.704 1.94303 6.5 1.94303C9.296 1.94303 11.481 4.09347 11.481 6.64782ZM12.481 6.64782C12.481 8.98343 10.4665 11.9014 8.4811 14.1544C7.42212 15.3561 5.57597 15.3575 4.51163 14.1606C2.47524 11.8704 0.519043 9.01248 0.519043 6.64782C0.519043 3.49715 3.19681 0.943024 6.5 0.943024C9.80319 0.943024 12.481 3.49715 12.481 6.64782ZM7.62392 6.64774C7.62392 7.1694 7.16655 7.67202 6.50164 7.67202C5.83674 7.67202 5.37936 7.1694 5.37936 6.64774C5.37936 6.12608 5.83674 5.62346 6.50164 5.62346C7.16655 5.62346 7.62392 6.12608 7.62392 6.64774ZM8.62392 6.64774C8.62392 7.76572 7.67374 8.67202 6.50164 8.67202C5.32954 8.67202 4.37937 7.76572 4.37937 6.64774C4.37937 5.52976 5.32954 4.62346 6.50164 4.62346C7.67374 4.62346 8.62392 5.52976 8.62392 6.64774Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationRounded);
export default __webpack_public_path__ + "static/media/location-rounded.768c687ad5bea976bc292c3fa6ab6229.svg";
export { ForwardRef as ReactComponent };